export const DEFAULT_TRANSITION_TIME = 1900;

export const MEDIA_TYPES = {
    VIDEO: 'video',
    IMAGE: 'image',
    LIVE: 'live',
};

export const BLOCK_TYPES = {
    IMAGE: 1,
    VIDEO: 2,
    SPEAKER: 3,
    MEDIA: 4,
    INLOOP_UITLOOP: 5,
    CONDOLENCE: 6,
    CALL: 7,
};

export const RENDER_STATES = {
    NONE: 'none',
    AUDIO_ONLY: 'audio-only',
    MEDIA_ONLY: 'media-only',
    FULL: 'full',
};

export const DURATION_STATES = {
    ACTIVE: 'active',
    IN_ACTIVE: 'inactive',
};

export const TIMER_STATES = {
    INIT: 'init',
    START: 'start',
    CONTENT: 'content',
    END: 'end',
};

export const BACKGROUND_TYPE = {
    COLOR: 'color',
    IMAGE: 'image',
    DYNAMIC_BACKGROUND: 'dynamic',
};

export const CONTROLS = {
    AUTO: 'auto',
    MANUAL: 'manual',
};

export const CHANNELS = {
    MEDIA: 'media',
    AUDIO: 'audio',
};

export const RENDER_TYPES = {
    ITEM: 'item',
    PLAYER_INDICATOR: 'player_indicator',
};

// Sync with player-v2/components/transitions/index.js
export const TRANSITION_TYPE = {
    DIP_TO_BLACK_FADE: 'dip_to_black',
    CROSS_FADE: 'cross_fade',
    // HEART: 'heart',
};
